module.exports = __webpack_public_path__ + "lato-light-90301aa07d780a09812229d6375c3b28.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-light/lato-light.woff
// module id = 1043
// module chunks = 0